import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cpl_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("cpl_token");
      localStorage.removeItem("cpl_user");
    }
    return Promise.reject(err);
  }
);

export const setAuth = (token, user) => {
  localStorage.setItem("cpl_token", token);
  localStorage.setItem("cpl_user", JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem("cpl_token");
  localStorage.removeItem("cpl_user");
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("cpl_user");
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};
